import { TrackByFunction } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

export const trackByCarrierId: TrackByFunction<UntypedFormControl> = (
  _index: number,
  control: UntypedFormControl,
): string => control?.carrier?.carrier_id;
